import { render, staticRenderFns } from "./inventoryLookUp.vue?vue&type=template&id=5c4facbc"
import script from "./inventoryLookUp.vue?vue&type=script&lang=js"
export * from "./inventoryLookUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports